// extracted by mini-css-extract-plugin
export default {"SplitPageLayout_Content":"CodeView-module__SplitPageLayout_Content--qxR1C"};